import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";

interface GlobalLoaderProps {
  description?: string;
  fullScreen?: boolean;
  className?: string;
  compensateSidebar?: boolean;
  initialPageLoad?: boolean;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({
  description = "Loading...",
  fullScreen = false,
  className,
  compensateSidebar = true,
  initialPageLoad = false
}) => {
  if (initialPageLoad) {
    return (
      <div className={cn(
        "fixed inset-0 flex items-center justify-center bg-transparent z-[1500] pointer-events-none",
        "ml-0 lg:ml-[240px]", // Compensate for sidebar width only on desktop
        className
      )}>
        <div className="flex flex-col items-center justify-center p-4">
          <Loader2 className="h-12 w-12 animate-spin text-[#885ABB]" />
          {description && (
            <p className="mt-2 text-sm text-gray-500 font-medium animate-pulse">
              {description}
            </p>
          )}
        </div>
      </div>
    );
  }

  if (!fullScreen) {
    return (
      <div className={cn(
        "flex flex-col items-center justify-center p-4",
        compensateSidebar && "md:-ml-28",
        className
      )}>
        <Loader2 className="h-12 w-12 animate-spin text-[#885ABB]" />
        {description && (
          <p className="mt-2 text-sm text-gray-500 font-medium animate-pulse">
            {description}
          </p>
        )}
      </div>
    );
  }

  // Full screen covering everything with background
  return (
    <div className="fixed inset-0 z-[1500] flex items-center justify-center bg-transparent">
      <div className="flex flex-col items-center">
        <div className="relative">
          <div className="h-16 w-16 rounded-full border-[6px] border-[#885ABB]/20 border-t-[#885ABB] animate-spin"></div>
        </div>
        {description && (
          <p className="mt-4 text-[#885ABB] font-medium animate-pulse tracking-wide">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default GlobalLoader;
